import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PaymentComponent from "@/builder/components/payment/PaymentComponent.vue";
import { MerchantType } from "@/enums";
import { useRenderStore } from "../../stores/renderStore";

const readOnly = false;

export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentRenderContainer',
  props: ["component"],
  setup(__props) {

const renderStore = useRenderStore();

const organizationId = renderStore.organizationId;

const merchantAccount = renderStore.merchantAccount ?? "";
const tokenizationKey = renderStore.tokenizationKey ?? "";
const props = __props;

const payPalGatewayId = renderStore.page.payPalGatewayId;
const payPalMerchantAccount = renderStore.page.payPalMerchantAccount;
const payPalCurrency = renderStore.page.payPalGatewayCurrency;
const merchantType = renderStore.page.merchantType ?? MerchantType.StripeUnified;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PaymentComponent, {
    component: props.component,
    organizationId: _unref(organizationId),
    merchantAccount: _unref(merchantAccount),
    tokenizationKey: _unref(tokenizationKey),
    readOnly: readOnly,
    payPalGatewayId: _unref(payPalGatewayId),
    payPalMerchantAccount: _unref(payPalMerchantAccount),
    payPalCurrency: _unref(payPalCurrency),
    merchantType: _unref(merchantType)
  }, null, 8, ["component", "organizationId", "merchantAccount", "tokenizationKey", "payPalGatewayId", "payPalMerchantAccount", "payPalCurrency", "merchantType"]))
}
}

})